import React, { useCallback, useState, useEffect } from "react";
import { connect } from "react-redux";

import Button from "sushiweb/Button";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import * as DriverStoriesActions from "../../../store/actions/DriverStories";
import Permission from "../../../components/Common/Permission";
import { FlexContainer, Heading } from "../../../constants/assets/containers";
import FilterButton from "../../../components/Common/FilterButton";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import ListPagination from "../../../components/Common/ListPagination";
import StoriesList from "../../../components/DriverStories/StoriesList";

export function StoriesCampaign(props) {
  const { nextPage, prevPage, fetchStoriesList, activeFilters, storiesList } =
    props;

  const [currentPage, setCurrentPage] = useState(1);
  const [modalState, setModalState] = useState(false);
  const history = useHistory();
  const allActions = MenuActionsMappings[MenuNames.DRIVER_STORIES];
  const handleCreateStoryClick = () => {
    props.resetState("createStory");
    history.push(`/stories/create_campaign`);
  };
  const handleCreateStoryBrandClick = () => {
    props.resetState("createStoryBrand");
    history.push(`/stories/create_external_entity`);
  }
  const handleViewStoryBrandsClick = () => {
    props.resetState("createStoryBrand");
    history.push(`/stories/view_external_entities`);
  }

  const handleViewDetails = useCallback((campaign_id) => {
    props.resetState("activeStoryDetails");
    history.push(`/stories/${campaign_id}`);
  }, []);

  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
        page_size: 10,
      };
      setCurrentPage(currentPage - 1);
      fetchStoriesList(activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
        page_size: 10,
      };
      setCurrentPage(currentPage + 1);
      fetchStoriesList(activeFilters, pageRequest);
    }
  };

  useEffect(() => {
    storiesList.length == 0 && fetchStoriesList();
  }, []);

  return (
    <div className="container">
      <FlexContainer align="flex-start" className="mb-20">
        <Heading>&emsp;All stories</Heading>
        <div className="actionBar flex items-center justify-end gap-4">
          <Permission requiredPerms={[allActions.STORIES_CREATE]}>
            <Button
              onClick={() => handleCreateStoryClick()}
              className="sushi-btn ml-12"
              data-testid="storyAddNewBtn"
            >
              Create Story
            </Button>
            <Button
              onClick={() => handleCreateStoryBrandClick()}
              className="sushi-btn ml-12"
              data-testid="externalBrandAddNewBtn"
            >
              Create External Brand
            </Button>
          </Permission>
          <Permission requiredPerms={[allActions.STORIES_VIEW]}>
            <Button
              onClick={() => handleViewStoryBrandsClick()}
              className="sushi-btn ml-12"
              data-testid="externalBrandsViewNewBtn"
            >
              View All Brands
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <Permission requiredPerms={[allActions.STORIES_VIEW]}>
        <StoriesList
          handleViewDetails={handleViewDetails}
          storiesList={storiesList}
        />
        <ListPagination
          nextPage={nextPage}
          prevPage={prevPage}
          handleNavClick={handleNavClick}
        />
      </Permission>
    </div>
  );
}

function mapStateToProps(state) {
  const { DriverStories } = state;
  return {
    nextPage: DriverStories.nextPage,
    prevPage: DriverStories.prevPage,
    activeFilters: DriverStories.activeFilters,
    storiesList: DriverStories?.driverStoriesList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetState: bindActionCreators(DriverStoriesActions.resetState, dispatch),
    fetchStoriesList: bindActionCreators(
      DriverStoriesActions.fetchStoriesList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StoriesCampaign);
